import { reject } from "../../../Common/TypingUtils";

export function extractGfvsFromFileName(target: string): string[] {
    const gfvRegexp = /\d{6,}/g;
    const result: string[] = [];
    let match: RegExpMatchArray | null;
    do {
        match = gfvRegexp.exec(target);
        if (match) {
            result.push(match[0] ?? reject());
        }
    } while (match);
    return result;
}
